import { NumberField, Switch } from "@justhome/react-ui";
import { FC } from "react";
import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useFormStep from "../../lib/useFormStep";
import FormStep from "../FormStep";

const EquityStep: FC = () => {
  const { t } = useTranslation();
  const { form, handleSubmit, handleBack } = useFormStep({
    next: "monthlyNetIncome",
  });

  const {
    control,
    formState: { errors },
  } = form;

  const { field } = useController({
    name: "equity",
    control,
    rules: {
      required: {
        value: true,
        message: t("equity.required"),
      },
    },
  });

  const { field: switchField } = useController({
    name: "wantsToSellAProperty",
    control,
  });

  return (
    <FormStep
      onBack={handleBack}
      onSubmit={handleSubmit}
      title={t("equity.title")}
      description={t("equity.description")}
    >
      <div className="space-y-3s">
        <NumberField
          {...field}
          autoFocus
          label={t("equity.label")}
          placeholder={t("equity.placeholder")}
          suffix="€"
          errorMessage={errors.equity?.message}
          data-testid="equity"
        />
        <div>
          <Switch
            size="sm"
            labelPosition="end"
            name={switchField.name}
            checked={!!switchField.value}
            onChange={switchField.onChange}
            label={t("equity.sellPropertyQuestion")}
          />
        </div>
      </div>
    </FormStep>
  );
};

export default EquityStep;
